// extracted by mini-css-extract-plugin
export var Chip = "index-module--Chip--06e49";
export var ChipLabel = "index-module--ChipLabel--e4d37";